import React, { useState, useEffect } from 'react';
import httpClient from '../../Api/axios';
import {
  FaBriefcase,
  FaCalendarAlt,
  FaSpinner,
  FaExclamationTriangle,
  FaUserFriends,
  FaRocket,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';

function Team() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const membersPerPage = 8;

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const response = await httpClient.get('/getall__team');

      let members = [];

      if (Array.isArray(response.data)) {
        members = response.data;
      } else if (response.data && typeof response.data === 'object') {
        if (Array.isArray(response.data.data)) {
          members = response.data.data;
        } else if (Array.isArray(response.data.teams)) {
          members = response.data.teams;
        } else if (Array.isArray(response.data.items)) {
          members = response.data.items;
        } else if (response.data._id) {
          members = [response.data];
        } else {
          members = Object.values(response.data).filter(item =>
            item && typeof item === 'object' && item.teamname
          );
        }
      }

      if (!Array.isArray(members)) {
        members = [];
      }

      setTeamMembers(members);
      setError(null);
    } catch (err) {
      setError(`Failed to fetch team members: ${err.message || 'Please try again later.'}`);
      console.error('Error fetching team:', err);
      setTeamMembers([]);
    } finally {
      setLoading(false);
    }
  };

  // Loading skeleton component
  const LoadingSkeleton = () => {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
          <div key={item} className="bg-white border border-gray-200 rounded-2xl overflow-hidden animate-pulse">
            <div className="bg-gray-200 h-72 w-full"></div>
            <div className="p-6 space-y-4">
              <div className="h-6 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white text-gray-900 py-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">

            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-gray-900">Meet Our</span>{' '}
              <span className="text-red-600">Experts</span>
            </h1>
            <p className="text-gray-600 text-lg">Loading our amazing team...</p>
          </div>
          <LoadingSkeleton />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full text-center">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <FaExclamationTriangle className="text-red-600 text-4xl" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Oops!</h2>
          <p className="text-gray-600 mb-8">{error}</p>
          <button
            onClick={fetchTeamMembers}
            className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold px-8 py-3 rounded-lg transition-all duration-300 transform hover:scale-105"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const membersArray = Array.isArray(teamMembers) ? teamMembers : [];

  // Filter out inactive members - only show those with status "Active"
  const activeMembersArray = membersArray.filter(member =>
    member?.status === "Active" || member?.status === "active"
  );

  // Pagination logic
  const indexOfLastMember = currentPage * membersPerPage;
  const indexOfFirstMember = indexOfLastMember - membersPerPage;
  const currentMembers = activeMembersArray.slice(indexOfFirstMember, indexOfLastMember);
  const totalPages = Math.ceil(activeMembersArray.length / membersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen bg-white text-gray-900">

     <section
  className="relative overflow-hidden h-[60vh] md:h-[75vh] px-4 md:px-8 bg-cover bg-center"
  style={{ backgroundImage: "url('/ourteam.png')" }} // image from public folder
>
  
</section>




      {/* Team Grid */}
      <section className="py-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          {activeMembersArray.length === 0 ? (
            <div className="text-center py-12">
              <div className="bg-white border border-gray-200 rounded-2xl p-8 md:p-12 max-w-md mx-auto shadow-lg">
                <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
                  <FaUserFriends className="text-gray-400 text-4xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {membersArray.length === 0 ? 'No Team Members Found' : 'No Active Team Members Found'}
                </h3>
                <p className="text-gray-600 mb-6">
                  {membersArray.length === 0
                    ? 'Add team members to see them displayed here.'
                    : 'All team members are currently inactive or no active members available.'}
                </p>
                <button
                  onClick={fetchTeamMembers}
                  className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold px-6 py-3 rounded-lg transition-all duration-300"
                >
                  Refresh
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {currentMembers.map((member) => (
                  <div
                    key={member?._id || Math.random()}
                    className="flex flex-col bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                  >
                    {/* Fixed Photo Container */}
                    <div className="relative w-full h-72">
                      <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-white"></div>
                      <img
                        src={member?.teamphoto || `https://ui-avatars.com/api/?name=${encodeURIComponent(member?.teamname || 'Team Member')}&background=ff4444&color=fff&size=400`}
                        alt={member?.teamname || 'Team Member'}
                        className="w-full h-full object-cover absolute inset-0"
                        onError={(e) => {
                          e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member?.teamname || 'Team Member')}&background=ff4444&color=fff&size=400`;
                        }}
                      />

                      {/* Gradient Overlay for Text Readability */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

                      {/* Name and Designation */}
                      <div className="absolute bottom-0 left-0 right-0 p-6">
                        <div className="mb-2">
                          <h3 className="text-2xl font-bold text-white mb-1 leading-tight">
                            {member?.teamname || 'Unknown Member'}
                          </h3>
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-red-600/30 flex items-center justify-center">
                              <FaBriefcase className="w-4 h-4 text-white" />
                            </div>
                            <span className="text-red-300 font-medium text-base">
                              {member?.teamdesignation || 'Not Specified'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Member Details */}
                    <div className="flex-1 flex flex-col p-5 space-y-4">
                      {/* Experience with Icon */}
                      <div className="flex items-center gap-3 pt-2">
                        <div className="w-12 h-12 rounded-xl bg-red-50 border border-red-100 flex items-center justify-center flex-shrink-0">
                          <FaCalendarAlt className="w-5 h-5 text-red-600" />
                        </div>
                        <div>
                          <div className="text-red-600 font-bold text-lg">
                            {member?.teamexperience || '0 Years'} Experience
                          </div>
                          <div className="text-gray-500 text-sm">Professional Expertise</div>
                        </div>
                      </div>

                      {/* Description */}
                      <div className="flex-1">
                        <div className="h-full border-l-2 border-red-200 pl-4">
                          <p className="text-gray-600 text-sm leading-relaxed line-clamp-4 h-full">
                            {member?.teamdescription || 'No description available.'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4">
                  <div className="text-gray-600">
                    Showing {indexOfFirstMember + 1} to {Math.min(indexOfLastMember, activeMembersArray.length)} of {activeMembersArray.length} members
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      <FaChevronLeft className="w-5 h-5" />
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                      <button
                        key={number}
                        onClick={() => paginate(number)}
                        className={`w-10 h-10 rounded-lg font-medium transition-colors ${currentPage === number
                            ? 'bg-red-600 text-white'
                            : 'border border-gray-300 text-gray-600 hover:bg-gray-50'
                          }`}
                      >
                        {number}
                      </button>
                    ))}

                    <button
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      <FaChevronRight className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </section>


    </div>
  );
}

export default Team;